import { render, staticRenderFns } from "./MaintenanceView.vue?vue&type=template&id=f0d6a662&scoped=true"
var script = {}
import style0 from "./MaintenanceView.vue?vue&type=style&index=0&id=f0d6a662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d6a662",
  null
  
)

export default component.exports